module.exports = __webpack_public_path__ + "static/media/acura-small-street-selected.ad54efd5.svg";